import { Component } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { services } from '../../services';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslationService } from '../../../../../../shared/services/translations.service';
import { CookieService } from 'ngx-cookie-service';

@Component({
  selector: 'apex-unranked-wins',
  templateUrl: './apex-unranked-wins.component.html'
})
export class ApexUnrankedWinsComponent {
  service = 'normalgames';
  availableServices = services['apex'].filter(service => service.service !== this.service);

  serviceParams = {
    game: 'apex',
    service: 'normalgames',
    type: 'solo',
    queue: 'unranked',
    title: {
      en: 'Unranked Wins',
    },
    subtitle: {
      en: 'Guaranteed Unranked Wins in Solo or Duo Boosting',
      fr: 'Victoires rapides garanties en Boost Solo ou Duo',
      de: 'Garantierte schnelle Siege im Solo- oder Duo-Boosting',
      pt: 'Vitórias Quick Match garantidas em Solo ou Duo Boosting',
      es: 'Victorias rápidas garantizadas en Solo o Duo Boosting',
    },
    start: 9,
    desired: 10,
    serviceName: {
      en: 'Wins',
      fr: 'Victoires',
      de: 'Siege',
      pt: 'Wins',
      es: 'Wins',
    },
    min: 1,
    max: 10
  }

  serviceFaqs = {
    en: [
      {
        question: "What Is An Unranked Win Boosting Service?",
        answer: "An Unranked Win is a non ranked service that guarantees a predetermined number of unranked wins."
      },
      {
        question: "Do Losses Count Towards Order Progression?",
        answer: "Only wins are counted, therefore when you purchase 10 Unrankted Wins, you are guaranteed to have played at least 10 games."
      },
      {
        question: "Can I Use This Service To Complete Missions, Challenges and Events?",
        answer: "Yes, you can. As long as the service is active we will try to complete as many as possible."
      },
      {
        question: "Can I Play With The Booster In Duo Queue Boosting?",
        answer: "Indeed, you can. To accomplish this, go to the order customization menu and select \"Duo\" before clicking \"Buy Boost Now\"."
      },
      {
        question: "Can I Choose My Preferred Legends?",
        answer: "Yes, you can. Click the \"Choose your Legends\" button in the order customization menu to make it happen."
      },
      {
        question: "Can I Request The Same Booster For A Future Purchase?",
        answer: "Yes! Click the heart icon inside the order dashboard to favorite a booster, then easily reassign them to your future orders."
      }
    ],
    fr: [
      {
        question: "Qu'est-ce qu'un service de boost de victoires non classées ?",
        answer: "Une victoire non classée est un service non classé qui garantit un nombre prédéterminé de victoires non classées."
      },
      {
        question: "Les défaites comptent-elles pour la progression de la commande ?",
        answer: "Seules les victoires sont comptées, donc si tu achètes 10 victoires non classées, tu es assuré d'avoir joué au moins 10 parties."
      },
      {
        question: "Puis-je utiliser ce service pour compléter des missions, défis et événements ?",
        answer: "Oui, tu peux. Tant que le service est actif, nous essaierons d'en compléter le maximum possible."
      },
      {
        question: "Puis-je jouer avec le booster en duo queue ?",
        answer: "Bien sûr ! Pour cela, va dans le menu de personnalisation de la commande et sélectionne \"Duo\" avant de cliquer sur \"Acheter le boost maintenant\"."
      },
      {
        question: "Puis-je choisir mes Légendes préférés ?",
        answer: "Oui, tu peux. Clique sur le bouton \"Choisir vos Légendes\" dans le menu de personnalisation de la commande."
      },
      {
        question: "Puis-je demander le même booster pour un prochain achat?",
        answer: "Oui ! Cliquez sur l\'icône en forme de cœur dans le tableau de bord de commande pour ajouter un booster en favori, puis réassignez-le facilement à vos prochaines commandes."
      }
    ],
    de: [
      {
        question: "Was ist ein Unranked-Win-Boosting-Service?",
        answer: "Ein Unranked-Win ist ein nicht gewerteter Service, der eine vorher festgelegte Anzahl an ungewerteten Siegen garantiert."
      },
      {
        question: "Werden Niederlagen für den Fortschritt der Bestellung gezählt?",
         answer: "Nur Siege werden gezählt, daher sind Sie garantiert mindestens 10 Spiele gespielt zu haben, wenn Sie 10 Unranked-Wins kaufen."
      },
      {
        question: "Kann ich diesen Service nutzen, um Missionen, Herausforderungen und Events abzuschließen?",
        answer: "Ja, kannst du. Solange der Service aktiv ist, werden wir versuchen, so viele wie möglich zu erfüllen."
      },
      {
        question: "Kann ich mit dem Booster in der Duo-Queue spielen?",
        answer: "Ja, das kannst du. Gehe dazu einfach ins Bestellmenü, wähle die Option \"Duo\" und klicke auf \"Boost jetzt kaufen\"."
      },
      {
        question: "Kann ich meine bevorzugten Legenden wählen?",
        answer: "Ja, kannst du. Klicke im Bestellmenü auf den Button \"Wähle deine Legenden\", um es einzurichten."
      },
      {
        question: "Kann ich denselben Booster für zukünftige Käufe anfordern?",
        answer: "Ja! Klicke im Bestell-Dashboard auf das Herzsymbol, um einen Booster zu deinen Favoriten hinzuzufügen, und weise ihn dann ganz einfach zukünftigen Bestellungen zu."
      }
    ],
    pt: [
      {
        question: "O que é um serviço de boost de vitórias unranked?",
        answer: "Uma vitória unranked é um serviço não competitivo que garante um número pré-determinado de vitórias em jogos não ranqueados."
      },
      {
        question: "As derrotas contam para o progresso da encomenda?",
        answer: "Só as vitórias contam. Assim, ao comprar 10 vitórias unranked, garantimos que jogarás pelo menos 10 partidas."
      },
      {
        question: "Posso usar este serviço para completar missões, desafios e eventos?",
        answer: "Sim, podes. Enquanto o serviço estiver ativo, tentaremos completar o máximo possível."
      },
      {
        question: "Posso jogar com o booster em duo queue?",
        answer: "Claro que sim! Para isso, vai ao menu de personalização da encomenda, seleciona \"Duo\" e clica em \"Comprar Boost Agora\"."
      },
      {
        question: "Posso escolher as minhas Legends preferidoa?",
        answer: "Sim, podes. Clica no botão \"Escolher as tuas Legends\" no menu de personalização da encomenda."
      },
      {
        question: "Posso pedir o mesmo booster para uma compra futura?",
        answer: "Sim! Clica no ícone de coração dentro do painel do pedido para marcar um booster como favorito e depois escolhe-o facilmente nos teus próximos pedidos."
      }
    ],
    es:[
      {
        question: "¿Qué es un servicio de aumento de victorias no clasificadas?",
        answer: "Una victoria no clasificada es un servicio no clasificado que garantiza un número predeterminado de victorias no clasificadas."
      },
      {
        question: "¿Las derrotas cuentan para el progreso del pedido?",
        answer: "Solo las victorias cuentan. Por lo tanto, si compras 10 victorias no clasificadas, tienes garantizado haber jugado al menos 10 partidas."
      },
      {
        question: "¿Puedo usar este servicio para completar misiones, desafíos y eventos?",
        answer: "Sí, puedes. Mientras el servicio esté activo, intentaremos completar tantos como sea posible."
      },
      {
        question: "¿Puedo jugar con el booster en una partida en dúo?",
        answer: "Claro que sí. Ve al menú de personalización del pedido, selecciona \"Dúo\" y haz clic en \"Comprar Boost Ahora\"."
      },
      {
        question: "¿Puedo elegir mis Leyendas preferidas?",
        answer: "Sí, puedes. Haz clic en el botón \"Elegir tus Leyendas\" en el menú de personalización del pedido."
      },
      {
        question: "¿Puedo solicitar al mismo booster para una compra futura?",
        answer: "¡Sí! Haz clic en el ícono de corazón dentro del panel del pedido para añadir un booster a favoritos y así poder reasignarlo fácilmente en tus futuros pedidos."
      }
    ]
  }

  private page = {
    title: {
      en: "Apex Legends - Quick Wins Boosting for Apex Legends",
      fr: "Apex Legends - Boosting de victoires rapides pour Apex Legends",
      de: "Apex Legends - Schnelle Siege Boosting für Apex Legends",
      pt: "Apex Legends - Boosting vitórias rápidas para Apex Legends",
      es: "Apex Legends - Boosting victorias rápidas para Apex Legends",
    },
    metaDescription: {
      en: "Rise in Apex Legends ranks with GGBoost. Opt for the Best and Safest boosting services, ensuring Standout Performance Every Match",
      fr: "Montez dans les rangs d'Apex Legends avec GGBoost. Optez pour les meilleurs services de boosting, assurant des performances exceptionnelles à chaque match",
      de: "Steige mit GGBoost in die Apex Legends auf. Entscheide dich für den besten und sichersten Boosting-Dienst, der dir in jedem Spiel hervorragende Leistungen gewährleistet.",
      pt: "Suba nos rankings do Apex Legends com GGBoost. Opte pelos melhores e mais seguros serviços de aumento de rank, garantindo um desempenho excepcional em cada partida",
      es: "Sube de nivel en Apex Legends con GGBoost. Opta por los mejores y más seguros servicios de boosting, garantizando un rendimiento sobresaliente en cada partido.",
    }
  }

  lang: string = 'en';

  constructor(meta: Meta, title: Title, private route: ActivatedRoute, private router: Router, private translationService: TranslationService, private cookie: CookieService) {
    this.route.params.subscribe(params => {
      if (Object.keys(params).length === 0) {
        const url = this.router.url.split('/');
        if (this.translationService.validLangs.includes(url[1])) {
          this.lang = url[1];
        } else {
          this.lang = this.cookie.get('gg-lang') || 'en';
        }
      } else {
        this.lang = params['lang'] || 'en';
      }
    });

    title.setTitle(this.page.title[this.lang] || this.page.title['en']);
    meta.updateTag(
      {
        name: 'description',
        content: this.page.metaDescription[this.lang] || this.page.metaDescription['en']
      }
    );
  }
}